import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { SearchAddressResult } from '@core/api/angular';

@Component({
  selector: 'lassi-property-result-list',
  imports: [
    RouterModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    FormsModule,
  ],
  template: `
    <mat-selection-list
      [multiple]="true"
      (selectionChange)="onSelectionChange($event)"
      [disabled]="disabled()"
    >
      @for (property of properties(); track property.pfi) {
        <mat-list-option
          [value]="property"
          class="result-checkbox-container"
          [selected]="isSelected(property)"
        >
          <span class="checkbox-label mat-label-medium">
            {{ property.displayTitle }}
          </span>
        </mat-list-option>
      } @empty {
        <div>No results.</div>
      }
    </mat-selection-list>
  `,
  styles: `
    @use '@angular/material' as mat;
    @use 'theme' as theme;
    @use 'breakpoints' as *;

    .result-checkbox-container {
      border-bottom: 1px solid #{mat.get-theme-color(
          theme.$light-theme,
          surface-variant
        )};
    }

    .checkbox-label {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyResultListComponent {
  properties = input.required<SearchAddressResult[]>();
  selectedProperties = model<SearchAddressResult[]>([]);
  disabled = input<boolean>(false);

  isSelected(property: SearchAddressResult): boolean {
    return this.selectedProperties().some((p) => p.pfi === property.pfi);
  }

  onSelectionChange(event: MatSelectionListChange) {
    const selectedProperties = event.source.selectedOptions.selected.map(
      (option) => option.value as SearchAddressResult,
    );
    this.selectedProperties.set(selectedProperties);
  }
}
